export const API_URL = `https://equbszd8yb.execute-api.ap-southeast-2.amazonaws.com/v1/staging`;
export const API_V2_URL = `https://prod-api-v2.campaignware.com`;
export const FACEBOOK_APP_ID = '876776595823581';
export const SHOW_ALL_PLAYERS_FOR_ALL_POS = [5440,5249,5331];